import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { useExpensesStore } from '../../store/expensesStore'
import { deleteExpense } from '../../utils/deleteExpense'
import type { ApiError } from '@/types/api'
import { notifyRequestError } from '@/utils/notifyRequestError'

export const useDeleteExpenseMutation = (onSuccess?: () => void) => {
  const removeExpense = useExpensesStore((state) => state.removeExpense)

  return useMutation({
    mutationFn: deleteExpense,
    onSuccess: ({ message, id }) => {
      removeExpense(id)
      toast.success(message || 'Expense deleted successfully.')
      onSuccess?.()
    },
    onError: (error: ApiError) => {
      notifyRequestError(error, 'An error occurred while deleting expense.')
    },
  })
}
